__turbopack_context__.v({
  "className": "inter_c1689ea3-module__rbyVfq__className",
});
